import appsetting from "@/store/app-settings/index.js";

const userData = function() {
  return JSON.parse(localStorage.getItem("userData"));
};

const isAdminRole = () => {
  const user = userData();
  return user.userDepartmentRole.isAdmin;
};

const isSecretary =() => {
  if (selectedRole() === appsetting.complaintRoleId.secretary) {
    return true;
  }
  return false;
};

const userId = function() {
  const user = userData();
  if (isAdminRole()) {
    return selectedAdminOfficer();
  }
  return user.id;
};

const userIdDefault = function() {
  const user = userData();
  return user.id;
};

const fullName = function() {
  const user = userData();
  return user.fname + " " + user.lname;
};

const username = function() {
  const user = userData();
  return user.username;
};

const departmentId = function() {
  const user = userData();
  if (isAdminRole()) {
    return selectedAdminDepartment();
  }
  //return user.divisioninfos[0].divisionId;
  return selectedDepartmentRole().value
};

const departmentIdDefault = function() {
  const user = userData();
  return selectedDepartmentRole().value
};

const departmentName = function() {
  const user = userData();
  return user.divisioninfos[0].divisionName;
};

const selectedAdminDepartment = () => {
  const user = userData();
  console.log("selectAdminDepartment", user.selectedAdminDepartment);
  if (user.selectedAdminDepartment === undefined) {
    //return user.divisioninfos[0].divisionId;
    return selectedDepartmentRole().value;
  }
  return user.selectedAdminDepartment;
};

const selectedAdminOfficer = () => {
  const user = userData();
  if (user.selectedAdminOfficer === undefined) {
    return user.id;
  }
  return user.selectedAdminOfficer;
};

const selectedDepartmentRole = () => {
  const user = userData();
  return user.selectedUserDepartment
};

const departmentRoles = () => {
  const user = userData();
  return user.userDepartmentRole.departmentRoles
};

const selectedUserRole = () => {
  const user = userData();
  return user.selectUserRole
};

const userRoles = () => {
  return selectedDepartmentRole().roles
};

// const roles = () => {
//   const user = userData();
//   return user.roles;
// };

const selectedRole = () => {
  const user = userData();
  return selectedUserRole().value;
};

const isProvincialRole = () => {
  if (appsetting.complaintRoleId.province === selectedUserRole().value) {
    return true;
  }
  return false;
};

const isAreaRole = () => {
  if (appsetting.complaintRoleId.area === selectedUserRole().value) {
    return true;
  }
  return false;
};

const province = () => {
  return selectedUserRole().province
};

const area = () => {
  return selectedUserRole().area
};

const district = () => {
  return selectedUserRole().district
};
export {
  userId,
  isAdminRole,
  userIdDefault,
  fullName,
  username,
  departmentId,
  departmentIdDefault,
  departmentName,
  //roles,
  selectedRole,
  province,
  area,
  selectedAdminDepartment,
  selectedAdminOfficer,
  isProvincialRole,
  
  selectedDepartmentRole,
  departmentRoles,
  selectedUserRole,
  userRoles,
  isAreaRole,
  isSecretary,
  district,
};
